var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-images",style:(!_vm.$kmsTheme ? null : _vm.$kmsTheme.styles.logo)},_vm._l((_vm.pictures),function(picture){return _c('img',{staticStyle:{"height":"100%"},attrs:{"src":_vm.$http.defaults.baseURL + 'digitalNoticeBoard/picture?picture_id=' + picture.noticePictureId + '&type=' + picture.type}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }